import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import IndexPage from "./pages/indexpage";
import PricingPage from "./pages/pricingpage";
import NotFoundPage from "./pages/notfoundpage";
import IntegrationPage from "./pages/integrationpage";
import BlogPage from "./pages/blogpage";
import BlogNewsPage from "./pages/blognewspage";
import ChangeLogPage from "./pages/changelogpage";
import AboutusPage from "./pages/aboutuspage";
import ContactPage from "./pages/contactpage";
import PrivacyPage from "./pages/privacypage";
import TermsPage from "./pages/termspage";
import ReviewPage from "./pages/reviewpage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/integration" element={<IntegrationPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blognews" element={<BlogNewsPage/>} />
        <Route path="/changelog" element={<ChangeLogPage/>} />
        <Route path="/about-us" element={<AboutusPage/>} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms-condition" element={<TermsPage />} />
        <Route path="/review" element={<ReviewPage />} />

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
  
}

export default App;
